module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/Option/images/level.311088a4.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Option/images/level.png
// module id = 2521
// module chunks = 11